<template>
  <el-dialog :body-padding="false" width="80vw" height="80vh" :append-to-body="true"
             :visible="$attrs.visible" title="系统日志" :close-on-press-escape="false" @closed="handleClosed">
    <sys-log :menu="$attrs.menu" :target-no="$attrs.targetNo"></sys-log>
  </el-dialog>
</template>

<script>
import SysLog from '@/component/sys-log/SysLog.vue';

export default {
  name: 'SysLogDialog',
  components: {SysLog},
  methods: {
    handleClosed() {
      this.$emit('update:visible', false);
    }
  }
}
</script>

<style scoped>

</style>